import soleado from "./soleado.gif";
import tormenta from "./lightning-storm.gif"
import nublado from "./nublado.gif";
import lluviaSoleado from "./lluviasoleado.gif"
import nubladoOscuro from "./nubladooscuro.gif"
import noche from "./luna.gif"
import cloudyNight from "./cloudyNight.gif"
import cloudysun from "./cloudysun.gif"

import elecstorm from "./elecstorm.gif"


export const fondos = {
    "09d": nublado,
    "03n": nublado,
    "01d": soleado,
    "01n":noche,
    "04d":nubladoOscuro,
    "04n":nubladoOscuro,

    "10d":lluviaSoleado,
    "02d":cloudysun,
    "02n":cloudyNight,
    "11n":elecstorm,
    "11d":elecstorm
  };